import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-why_us-type04',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './why_us-type04.component.html',
  styleUrl: './why_us-type04.component.scss'
})
export class WhyUsType04Component {

}
